import React from "react";
import { useAuth } from "../../contexts/AuthContext";

const SignOutButton: React.FC = () => {
  const { signOut, loading } = useAuth();
  return (
    <button
      onClick={signOut}
      disabled={loading}
      style={{
        padding: "0.5rem 1.2rem",
        borderRadius: "1.5rem",
        background: "#e97d7d",
        color: "#fff",
        border: "none",
        fontWeight: 600,
        cursor: "pointer",
      }}
    >
      {loading ? "Signing out..." : "Sign Out"}
    </button>
  );
};

export default SignOutButton;
